import React from "react";
import { columns } from "./Columns";
import BaseTable from "./BaseTable";
import { adminListDataApiEndPoint, auditLogsApi } from "@/apis/apis";
import { useGet } from "@/apiHooks/HttpFunctions";
import { LIST_MODE } from "@/constant/Lists/listMode";
import { FILTER_TYPE } from "@/constant/constants";

export default function AuditLogsPage() {
  const { data: adminData } = useGet({
    apiURL: adminListDataApiEndPoint,
    params: {
      mode: LIST_MODE.ALL,
    },
  });

  const adminOptions = [
    { value: "", label: "All" },
    ...(adminData?.data?.map((admin) => {
      return {
        value: admin.first_name,
        label: admin.first_name,
      };
    }) || []),
  ];

  const additionalFilters = [
    {
      id: "filter[causer]",
      label: "Causer",
      type: FILTER_TYPE.SELECT,
      options: adminOptions,
    },
    {
      id: "filter[time_range]",
      label: "Time Range",
      type: FILTER_TYPE.DATE,
    },
  ];

  return (
    <BaseTable
      label="Audit Logs "
      apiURL={auditLogsApi}
      columns={columns()}
      enableSortData={false}
      enableStatus={false}
      enableExport={false}
      enableAdd={false}
      additionalFilters={additionalFilters}
    />
  );
}
